import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../../../reducers/types";
import {
  fetchCars,
  fetchFlights,
  fetchHotels,
  fetchHomes,
  fetchPackages,
} from "../../../../actions/actions";
import MissingItinerariesBanner from "./component";
import {
  getTripsFilter,
  getFetchUpcomingHomesFailed,
  getFetchUpcomingHotelsFailed,
  getFetchPastFlightsFailed,
  getFetchPastHotelsFailed,
  getFetchUpcomingFlightsFailed,
  getFetchUpcomingCarsFailed,
  getFetchPastCarsFailed,
  getFetchPastHomesFailed,
  getFetchPastPackagesFailed,
  getFetchUpcomingPackagesFailed,
} from "../../../../reducer";
import { isPostBookingOfferMyTripsEnabledSelector } from "../../../../../DisruptionProtection/reducer";

const mapStateToProps = (state: IStoreState) => ({
  tripsFilter: getTripsFilter(state),
  pastFlightsFailed: getFetchPastFlightsFailed(state),
  upcomingFlightsFailed: getFetchUpcomingFlightsFailed(state),
  pastHotelsFailed: getFetchPastHotelsFailed(state),
  upcomingHotelsFailed: getFetchUpcomingHotelsFailed(state),
  pastHomesFailed: getFetchPastHomesFailed(state),
  upcomingHomesFailed: getFetchUpcomingHomesFailed(state),
  pastCarsFailed: getFetchPastCarsFailed(state),
  upcomingCarsFailed: getFetchUpcomingCarsFailed(state),
  pastPackagesFailed: getFetchPastPackagesFailed(state),
  upcomingPackagesFailed: getFetchUpcomingPackagesFailed(state),
  isPostBookingOfferMyTripsEnabled:
    isPostBookingOfferMyTripsEnabledSelector(state),
});

const mapDispatchToProps = {
  fetchHotels,
  fetchHomes,
  fetchFlights,
  fetchCars,
  fetchPackages,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IMissingItinerariesBannerConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMissingItinerariesBanner = connector(
  withRouter(MissingItinerariesBanner)
);
